<template>
  <div class="page" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageLeft>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content">    
                <div class="image"><transition name="fade" mode="out-in" appear><img src="@/assets/images/features_and_amenities/ticketing.jpg" alt=""></transition></div>                        
                  <div class="page-content content">
                    <transition name="slide-fade" mode="out-in" appear>
                      <TitleContent h2="Features & Amenities" h1="Ticketing" />
                    </transition>
                    <transition name="slide-fade" mode="out-in" appear>
                      <div class="text-content">                                              
                        <p>Allegiant Stadium utilizes <a class="yellow" target="_blank" href="https://www.ticketmaster.com/safetix">Ticketmaster SafeTix.</a> Ticketmaster SafeTix are encrypted mobile tickets built with leading-edge technology, developed with the fan in mind, and come standard with powerful fraud and counterfeit protection.</p>
                        <p class='yellow'>Benefits of Allegiant Stadium’s ticketing platform include:</p>
                        <FeatureListItem icon="features_and_amenities/icon_ticket.svg" description="Access to real-time ticket counts"/>
                        <FeatureListItem icon="features_and_amenities/icon_resell.svg" description="Unauthorized resell protection"/>
                        <FeatureListItem icon="features_and_amenities/icon_communication.svg" description="Real-time fan communication"/>
                        <FeatureListItem icon="features_and_amenities/icon_protection.svg" description="Ticket bot protection"/>
                        <FeatureListItem icon="features_and_amenities/icon_unlock.svg" description="Promoter scaling access"/>                       
                      </div>                    
                    </transition>
                  </div>                
            </div>
        </div>
    </template>
    </PageLeft>    
  </div>
</template>

<script>
import PageLeft from "@/patterns/PageLeft.vue";
import TitleContent from "@/patterns/TitleContent.vue";
import FeatureListItem from "@/patterns/FeatureListItem.vue";

export default {
  name: "TheStadium",
  components: { PageLeft, TitleContent, FeatureListItem },
  data: () => ({
    scrollContent: false,    
  }),  
  mounted() {
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  },
  methods: {
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  position: relative;
  &:after {
    content: " ";
    bottom:0;
    left:0;
    height:1px;
    width: 100%;
    position:absolute;
    background: linear-gradient(269deg, #f5831f 0%, #fed208 100%)
  }
}
</style>